import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bsc-economics',
  templateUrl: './bsc-economics.component.html',
  styleUrls: ['./bsc-economics.component.scss']
})
export class BscEconomicsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
